import { render, staticRenderFns } from "./FilterRolesModal.vue?vue&type=template&id=535dac24&scoped=true"
import script from "./FilterRolesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterRolesModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterRolesModal.vue?vue&type=style&index=0&id=535dac24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535dac24",
  null
  
)

export default component.exports